import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Mail,
  Lock,
  Eye,
  EyeOff,
  LogIn,
} from "lucide-react";

import API from "../../services/api";
import "../css/AdminLogin.css";

function AdminLogin() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    setError("");

    try {
      setLoading(true);

      const { data } = await API.post("/auth/login", form);

      const { token, user } = data;

      if (user.role !== "admin") {
        setError("Access denied. Admin only.");
        return;
      }

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      navigate("/admin/dashboard");
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Unable to login. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">

      {/* Background Glow */}
      <div className="bg-circle bg-circle-1"></div>
      <div className="bg-circle bg-circle-2"></div>
      <div className="bg-circle bg-circle-3"></div>
      <div className="bg-circle bg-circle-4"></div>

      <div className="admin-login-card">

        <img
          src="/images/logo.png"
          alt="HomeFoods"
          className="admin-logo"
        />

        <h1>HomeFoods Admin Portal</h1>

        <p>
          Secure Control Center for HomeFoods
        </p>

        <form onSubmit={handleLogin}>

          <div className="input-group">

           

            <div className="input-box">

              <Mail size={20} />

              <input
                type="email"
                name="email"
                placeholder="admin@homefoods.in"
                value={form.email}
                onChange={handleChange}
                autoComplete="email"
                required
              />

            </div>

          </div>

          <div className="input-group">

           

            <div className="input-box">

              <Lock size={20} />

              <input
                type={
                  showPassword
                    ? "text"
                    : "password"
                }
                name="password"
                placeholder="Enter your password"
                value={form.password}
                onChange={handleChange}
                autoComplete="current-password"
                required
              />

              <button
                type="button"
                className="eye-btn"
                onClick={() =>
                  setShowPassword(!showPassword)
                }
              >
                {showPassword ? (
                  <EyeOff size={20} />
                ) : (
                  <Eye size={20} />
                )}
              </button>

            </div>

          </div>

          {error && (
            <div className="login-error">
              {error}
            </div>
          )}
                    <button
            type="submit"
            className="login-btn"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="btn-loader"></span>
                Signing In...
              </>
            ) : (
              <>
                <LogIn size={20} />
                Login to Dashboard
              </>
            )}
          </button>

        </form>

        <div className="login-footer">
          <p>© 2026 HomeFoods. All Rights Reserved.</p>
        </div>

      </div>

    </div>
  );
}

export default AdminLogin;